module.exports = __webpack_public_path__ + "img/select-icon.24d85ddd.png";